
/* dome nuit au scroll (desktop) comme sur la home, reveal simple sur mobile */
(function(){
  var n=document.querySelector('.s-night.sn-static'); if(!n) return;
  var sc=n.querySelector('.sn-scene');
  var RED=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io=null;
  function mobile(){return innerWidth<=1100||RED;}
  function setupMobile(){
    sc.style.clipPath=''; window.__snCov=1;
    if(io||!RED) return;
    if(!('IntersectionObserver' in window)){n.classList.add('sn-on');return;}
    io=new IntersectionObserver(function(e){if(e[0].isIntersecting){n.classList.add('sn-on');io.disconnect();io=null;}},{threshold:.15});io.observe(n);
  }
  function domeMobile(){
    if(RED){ sc.style.clipPath=''; return; }
    var top=n.getBoundingClientRect().top, vh=innerHeight, H=sc.offsetHeight;
    n.classList.toggle('sn-on', top<vh*0.05);
    if(top<0){ sc.style.clipPath='none'; return; }
    var p=Math.min(1,Math.max(0,1-top/vh)), R=H*(0.93+0.07*Math.pow(p,1.2));
    sc.style.clipPath='ellipse(170% '+R.toFixed(0)+'px at 50% '+H+'px)';
  }
  function upd(){
    if(mobile()){ setupMobile(); domeMobile(); return; }
    var r=n.getBoundingClientRect(), vh=innerHeight, D=Math.max(1,n.offsetHeight-vh);
    var p=Math.min(1,Math.max(0,-r.top/D));
    var g=Math.min(1,p/0.68); g=1-Math.pow(1-g,1.6);
    var W=sc.offsetWidth, H=sc.offsetHeight, R=Math.sqrt(Math.pow(W/2,2)+Math.pow(H*1.25,2))*1.02;
    sc.style.clipPath = g>=1 ? 'none' : 'circle('+(g*R).toFixed(1)+'px at 50% 125%)';
    n.classList.toggle('sn-on', g>0.9);
    window.__snCov=g;
  }
  var cn=document.querySelector('.sx-cercle.cs');
  function cnTop(){ if(cn) cn.style.setProperty('--cnTop',(innerHeight-cn.offsetHeight)+'px'); }
  cnTop(); addEventListener('resize',cnTop);
  var tk=false; function onS(){ if(!tk){ tk=true; requestAnimationFrame(function(){ tk=false; upd(); }); } }
  addEventListener('scroll',onS,{passive:true}); addEventListener('resize',onS); upd();
})();
